<template>
  <button
    type="button"
    class="purple-button"
    :class="{ 'container-tooltip': tooltip }"
    @click="$emit('action')"
    :disabled="disabled"
  >
    <span class="tooltiptext">{{ tooltipContent }}</span>

    <div class="content" :class="{ blocked: disabled }">
      <i v-if="!!icon" :class="icon"></i>
      <img v-else :src="image" class="image-icon" />
      <img src="@/assets/images/btn-stars.png" class="image-stars" />

      <div class="d-flex flex-column text-left">
        <span class="text-primary font-weight-bold">
          {{ title }}
        </span>
        <span class="small-text text-secondary">
          {{ description }}
        </span>
      </div>
    </div>
  </button>
</template>
<script>
// prop imagem deve ser -> require(path-to-image)
// assim quando chegar aqui recebo data:image

export default {
  props: {
    title: {
      type: String,
      default: "Título"
    },
    description: {
      type: String,
      default: "Description"
    },
    image: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    tooltipContent: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.purple-button {
  border: 1px dashed #d2d0d8;
  border-radius: 4px;
  width: 100%;
  padding: 0;

  .tooltiptext {
    visibility: hidden;
    width: 200px;
    font-size: 12px;
    color: #fff;
    font-weight: normal;
    background-color: #393444;
    border-radius: 4px;
    position: absolute;
    left: 20%;
    transform: translateX(-20%);
    margin-top: 60px;
    z-index: 1;
    padding: 8px;
  }

  .content {
    &.blocked {
      opacity: 0.5;
    }

    padding: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    background-color: rgba($color: #5576ec, $alpha: 0.05);
    border-radius: 4px;
    position: relative;

    .image-stars {
      position: absolute;
      left: 2%;
      transform: translateX(-2%);
      max-height: 70%;
    }

    .image-icon {
      max-height: 70%;
      margin-left: 8px;
      margin-right: 20px;
    }

    i {
      font-size: 38px;
      margin-left: 8px;
      margin-right: 20px;
      color: #5576ec;
    }
  }

  &.container-tooltip {
    &:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
